import React, { useEffect, useMemo, useRef, useState } from 'react'
import TableGrid from "../../../../Components/common/TableGrid";
import TableFilters from '../../../../Components/common/TableGrid/TableFilters';
import { useDispatch, useSelector } from 'react-redux';
import { useGetInboundShipmentListQuery, useGetWareHouseListQuery } from '../../../../redux/services/SPL';
import TableTabs from "../../../../Components/common/TableGrid/TableTabs";
import { onTabChange } from '../../../../redux/features/table/tableSlice';
import { CallApi} from '../../../../Components/common/CommonFunctions';
import {GETOWNERCODE } from '../../../../Utils/conts';
import { Card, Col, Row } from 'react-bootstrap';
import CommonCard from '../../../../Components/common/CommonCard';

import tripstoday from '../../../../assets/images/slotplanning/tripstoday.svg';
import onpremises from '../../../../assets/images/slotplanning/onpremises.svg';
import inprogress from '../../../../assets/images/slotplanning/inprogress.svg';
import arriving from '../../../../assets/images/slotplanning/arriving.svg';

const Warehouse = () => {
  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [getOwnerCodes, setGetOwnerCode] = useState([]);
  const [warehouseStats,setWarehouseStats] = useState({})
  const isMounted = useRef(false);
  const dispatch = useDispatch();
  const buildFilterParams = (filtersObj) => {
    const params = {};
    Object.entries(filtersObj).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
        return;
      }
      if (Array.isArray(value)) {
        params[key] = JSON.stringify(value);
      } else {
        params[key] = value;
      }
    });
    if (Object.keys(params).length > 0) {
      params.is_filter = true;
    }
    return params;
  };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);
    const params = {
      ...filterParams,
      type: 'warehouse',
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
    };
    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }
    if (tab?.value && tab.value !== "all" && tab.key) {
      params[tab.key] = tab.value;
    }
    return params;
  }, [filters, pageDetails, sortby]);

   useEffect(() => {
      dispatch(onTabChange({ key: 'tab', value: "A" }));
      if (isMounted.current) return;
      fetchWarehouse();
      fetchOwnerCode();
      fetchWarehouseStats()
      isMounted.current = true;
    }, []);

  const { data: myData, isFetching, refetch } = useGetInboundShipmentListQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  const columns = [
    { label: "AWB No.", field: "awb_no", enableSearch: false, cls: "tw-8" },
    { label: "Pieces Received", field: "pcs_rcvd", enableSearch: false, cls: "tw-8", renderCell : (row) =>{
      const Pieces_Received = row?.fsu_message_clean?.total_actual_pieces_awb;
      return (Pieces_Received);
      // return (
      //   <>
      //     <div className="d-flex justify-content-center">
      //       <span>{Pieces_Received || "-"}</span>
      //     </div>
      //   </>
      // )
    } },
    {
      label: "Weight Received", field: "wght_rcvd", enableSearch: false, cls: "tw-8",
      renderCell: (row) => {
        const weight_rcvd = row?.fsu_message_clean?.total_actual_weight_awb;
        return (weight_rcvd);
      }
     },
    { label: "Warehouse", field: "warehouse", enableSearch: false, cls: "tw-8", renderCell:(row) => {
      const warehouse = row?.warehouse?.name;
      return(warehouse);
    }},
    { label: "Flight No", field: "flight_no", enableSearch: false, cls: "tw-8", renderCell:(row) => {
      const flight_no = row?.rfs_monitor_handler_inbound_flight?.flight_no;
      return(flight_no);
    } },
    { label: "Flight Date", field: "flight_date", enableSearch: false, cls: "tw-8", renderCell:(row) => {
      const flight_no = row?.rfs_monitor_handler_inbound_flight?.flight_date;
      return(flight_no);
    }},
    { label: "Received Time", field: "warehouse_assign_date", enableSearch: false, cls: "tw-8" },
    { label: "Time in warehouse", field: "total_days", enableSearch: false, cls: "tw-8",},
    { label: "Departed PCs", field: "loading_dep", enableSearch: false,}
  ];

  const tabsConfig = [
    { label: "All", value: "all", paramKey: null },
    { label: "Open", value: "A", paramKey: "tab" },
    { label: "Archive", value: "R", paramKey: "tab" },
  ];

  const filtersConfig = [
    {
      type: "input",
      field: "awb_no",
      placeholder: "Search AWB No.",
    },
    {
      type: "input",
      field: "flight_no",
      placeholder: "Search Flight No.",
    },
    {
      type: "multiselect",
      field: "flight_prefix",
      placeholder: "Flight Prefix",
      options: getOwnerCodes,
    },
    {
      type: "multiselect",
      field: "warehouse_id",
      placeholder: "Warehouse",
      options: warehouseOptions,
    },
  ];

  const fetchWarehouse = async () => {
    CallApi({
      endPoint: "warehouse/list",
      method: "post",
      payload: {
        org_station_id: JSON.parse(
          localStorage.getItem("Handler_stn") || "{}"
        ).org_station_id
      },
      onSuccess: (res) => {
        const innerData = res.data.response_data;
        const transformedData = innerData ? innerData.map(item => ({
          value: item.id,
          label: item.name
        })) : [];
        setWarehouseOptions(transformedData);
      },
      onError: (msg) => console.error(msg)
    });
  };

  const fetchOwnerCode = async () => {
    CallApi({
      endPoint: GETOWNERCODE,
      method: "post",
      onSuccess: (res) => {
        const innerData = res.data.response_data;
        const transformedData = innerData ? innerData.map(item => ({
          value: item.IATA,
          label: item.IATA
        })) : [];
        setGetOwnerCode(transformedData);
      },
      onError: (msg) => console.error(msg)
    });
  };

    const cards = [
    { icon: 'tripstoday', title: 'Open Shipments', value: warehouseStats.open_shipments },
    { icon: 'arriving', title: 'Pieces in Warehouse', value: warehouseStats?.pieces_in_warehouse },
    { icon: 'inprogress', title: 'Average time in warehouse', value: warehouseStats?.avg_time_in_warehouse },
    { icon: 'inprogress', title: 'In Warehouse (+72h)', value: warehouseStats?.in_warehouse_72h },
  ] 
  const iconMap = { tripstoday, onpremises, inprogress, arriving, };

  const fetchWarehouseStats = () =>{
    CallApi({
      endPoint: "inbound-flights/shipment-warehouse-stats",
      method: "GET",
      onSuccess: (res) => {
        console.log("ressss",res)
        if(res?.status === 200){
          const innerData = res.data;
          setWarehouseStats(innerData)
        }
      },
      onError: (msg) => console.error(msg)
    });
  }
  console.log("warehouseStatssss",warehouseStats)

  return (
    <div className="main-content">
      {cards?.length ?
        <div className="card-bx">
          {cards?.map((item, index) => (
            <CommonCard icon={iconMap[item.icon]} title={item.title} value={item.value} btn={item.btn} />
          ))}
        </div>
        : <></>
      }
      <div className="d-flex justify-content-between align-items-center mb-3">
        <TableFilters filtersConfig={filtersConfig} />
        <TableTabs tabs={tabsConfig} />
      </div>
      <TableGrid
        columns={columns}
        rows={myData?.Rows}
        totalRecords={myData?.TotalRows || 0}
        onClickRow={(row) => {
          console.log("Clicked Row:", row);
        }}
        checkboxSelection={true}
        loading={isFetching}
        // bulkActions={bulkActions}
        rowKey="id"
      />
    </div>
  )
}

export default Warehouse